import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { motion } from 'framer-motion';
import { setPageMeta } from '../utils/seo';
import stackbg from '../Assets/stackbg.png';
import './Home.css';

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: (delay = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay, ease: 'easeOut' },
  }),
};

const Stack = () => {
  useEffect(() => {
    setPageMeta('Sapiencia.AI — Security Stack', 'Discover where Sapiencia fits in your AI security stack.');
  }, []);

  return (
    <div className="home-container">
      <Navbar />

      <section
      className="diagram-section stack-fit"
      style={{
       backgroundImage: `
        linear-gradient(
        rgba(5, 10, 20, 0.82),
        rgba(5, 10, 20, 0.88)
        ),
        url(${stackbg})`,
       backgroundSize: 'cover',
       backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
      }}>
        <motion.div
          className="diagram-wrapper"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.4 }}
        >
          <p className="eyebrow">SECURITY STACK</p>
          <h2 className="diagram-title">Where Sapiencia Fits in Your AI Security Stack</h2>

          <div className="stack-diagram">

            <motion.div className="stack-layer top" variants={fadeUp} custom={0.1}>
              <h4>Applications & AI Systems</h4>
              <p>Healthcare AI • Defense Systems • Enterprise AI</p>
            </motion.div>

            <motion.div className="stack-layer sapiencia" variants={fadeUp} custom={0.2}>
              <h4>Sapiencia AI Security Layer</h4>
              <ul>
                <li>Model Guardrails & Policy Enforcement</li>
                <li>Explainability & Audit Logs</li>
                <li>Threat Detection & Drift Monitoring</li>
              </ul>
            </motion.div>

            <motion.div className="stack-layer mid" variants={fadeUp} custom={0.3}>
              <h4>Identity & Zero Trust Access</h4>
              <p>IAM • RBAC • Secure Authentication</p>
            </motion.div>

            <motion.div className="stack-layer base" variants={fadeUp} custom={0.4}>
              <h4>Infrastructure & Data</h4>
              <p>Cloud • Edge • On-Prem • Air-Gapped</p>
            </motion.div>

          </div>

          <p className="diagram-caption">
            Sapiencia overlays your existing infrastructure, enforcing AI-specific security,
            compliance, and observability without replacing your stack.
          </p>
        </motion.div>
      </section>

      <Footer />
    </div>
  );
};

export default Stack;
